
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[post]",
      function () {
        return require("private-next-pages/[lang]/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[post]"])
      });
    }
  